import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PresentClass;
function Present() {
  if (PresentClass === VOID) {
    class $ extends Optional() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'Present(value=' + toString(this.value_1) + ')';
      }
      hashCode() {
        return this.value_1 == null ? 0 : hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Present()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Present');
    PresentClass = $;
  }
  return PresentClass;
}
var AbsentClass;
function Absent() {
  if (AbsentClass === VOID) {
    class $ extends Optional() {
      constructor() {
        Absent_instance = null;
        super();
        Absent_instance = this;
      }
      toString() {
        return 'Absent';
      }
      hashCode() {
        return -813336043;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Absent()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Absent');
    AbsentClass = $;
  }
  return AbsentClass;
}
var Absent_instance;
function Absent_getInstance() {
  if (Absent_instance === VOID)
    new (Absent())();
  return Absent_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      absent_njrah3_k$() {
        return Absent_getInstance();
      }
      present_fg06t6_k$(value) {
        return new (Present())(value);
      }
      presentIfNotNull_z0sdzu_k$(value) {
        return value == null ? Absent_getInstance() : new (Present())(value);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var OptionalClass;
function Optional() {
  if (OptionalClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Optional');
    OptionalClass = $;
  }
  return OptionalClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Present as Present1shu3953j96zb,
  Optional as Optional8wzzg0qzssox,
  Absent_getInstance as Absent_getInstance2zpu0zcae0yg1,
  Companion_instance as Companion_instanceldqbxvjihuns,
};
//endregion

//# sourceMappingURL=Optional.mjs.map
